import { useTranslation } from 'react-i18next'

import { ButtonSmall, CustomLink } from 'src/components/ui'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { ParticipantUser } from '../../Bottles.types'
import styles from './ParticipantsSection.module.scss'

interface ParticipantsSectionProps {
  type: 'ANY' | 'FIXED' | string
  amount: number
  participantsList: ParticipantUser[] | undefined
  children: React.ReactNode
}

const ParticipantsSection = ({ type, amount, participantsList, children }: ParticipantsSectionProps) => {
  const myName = useGlobalStore((store) => store.user?.username)
  // let indexOfUser = participantsList?.findIndex((participant) => participant.user.username === myName)

  const { t } = useTranslation()

  // const handleClickJoin = () => {
  //   if (type === 'ANY' || type === 'CHARITABLE') {
  //     // navigate('attachment')
  //     return
  //   } else {
  //     // setIsActiveModal(true)
  //   }
  // }

  return (
    <>
      <div className={styles.participants_header}>
        <p className={styles['participants_header-title']}>{t('bottle_page.list_of_participants')}</p>
        <ButtonSmall path='participants' />
      </div>

      {children}

      <div className={styles.participants_footer}>
        <CustomLink to='attachment' variant='contained' color='violet'>
          {t('bottle_page.exchange.stars_for_tickets')}
        </CustomLink>

        {/* NOT MVP */}
        {/* {type === 'ANY' || type === 'CHARITABLE' ? (
          indexOfUser === -1 ? (
            <CustomLink to='attachment' variant='contained' color='violet'>
              {t('bottle_page.join')}
            </CustomLink>
          ) : (
            <CustomLink to='attachment' variant='contained' color='violet'>
              {t('bottle_page.increase_the_contribution')}
            </CustomLink>
          )
        ) : indexOfUser === -1 ? (
          <CustomButton onClick={handleClickJoin} variant='contained' color='violet'>
            {t('bottle_page.join_for')} {formattedText(amount)}
            <Icon name='star' />
          </CustomButton>
        ) : (
          <CustomButton variant='not-active'>{t('bottle_page.you_are_already_member')}</CustomButton>
        )} */}
      </div>
    </>
  )
}

export default ParticipantsSection
